import { useCart } from '@/context/CartContext';

function FinalCTASection() {
  const { setIsOpen } = useCart();

  return (
    <section className="py-14 md:py-20 bg-primary-700">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3">
          Escolha suas peças favoritas
        </h2>
        <p className="text-base text-white/85 mb-6 max-w-lg mx-auto">
          Monte seu carrinho e envie o pedido pelo WhatsApp. Nossa equipe confirma disponibilidade, pagamento e entrega.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#catalogo"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#catalogo')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-primary-700 font-medium hover:bg-white/90 transition-colors whitespace-nowrap"
          >
            Ver catálogo
            <i className="ri-arrow-right-line" />
          </a>
          <button
            type="button"
            onClick={() => setIsOpen(true)}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-600 border border-white/30 text-white font-medium hover:bg-primary-500 transition-colors whitespace-nowrap"
          >
            <i className="ri-shopping-bag-line" />
            Ver carrinho
          </button>
        </div>
      </div>
    </section>
  );
}

export default FinalCTASection;